module.exports = {
  "metadata": {
    "width": "22",
    "height": "24",
    "name": "trash"
  },
  "source": "<path d=\"M16.11 23.14H5.84a.89.89 0 0 1-.89-.8L3.48 7.78a.89.89 0 0 1 1.78-.18l1.39 13.76h8.65L16.7 7.6a.89.89 0 0 1 1.77.18L17 22.34a.89.89 0 0 1-.89.8zm4.77-19.25l-2.6-1.19a.9.9 0 0 0-.37-.08h-4.44A1.78 1.78 0 0 0 11.69.86h-1.43a1.78 1.78 0 0 0-1.78 1.78H4.09a.89.89 0 0 0-.37.08L1.07 3.94a.89.89 0 0 0 .37 1.7.88.88 0 0 0 .37-.08l2.47-1.13h13.43l2.42 1.11a.89.89 0 1 0 .74-1.62zM9.36 18.5a.89.89 0 0 0 .82-1L9.6 9.88a.89.89 0 0 0-1.77.12l.58 7.66a.89.89 0 0 0 .89.82zm4-.82L14 10a.89.89 0 1 0-1.77-.13l-.58 7.66a.89.89 0 0 0 .82 1h.07a.89.89 0 0 0 .84-.85z\"/>"
};